export default class Modale {
  constructor(element) {
    this.element = element;
    this.closeBtn = this.element.querySelector('.js-modale-btn');

    this.init();
  }

  init() {
    // Close button
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.close.bind(this));
    }

    // Click outside
    this.element.addEventListener('click', this.onClickOutside.bind(this));
  }

  close() {
    this.element.classList.add('is-closed-modale');
  }

  onClickOutside(event) {
    if (event.target === this.element) {
      this.close();
    }
  }
}


// Event listener on loaded DOM
document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll('.open-modal').forEach(btn => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.postId;
      const modal = document.getElementById('modal-' + id);

      if (modal) {
        modal.classList.remove('is-closed-modale');
      }
    });
  });

});
